module.exports = __webpack_public_path__ + "img/seedpaper-black.e70907c7.png";